import { useQuery } from '@tanstack/react-query';
import { getCompanyArea } from 'services/api/requests/requests';

export const useCompanyAreaList = () => {
	return useQuery(['companyArea-list'], getCompanyArea, {
		refetchOnWindowFocus: false,
	});
};
